module.exports = __webpack_public_path__ + "static/media/icon_marketing.e86a2270.svg";